export default "__VITE_ASSET__OfKhCvwk__"